import { mixpanel } from '@fiverr-private/obs';

export default {
    trackEvent: (eventName, payload) => {
        mixpanel.track(eventName, payload);
    },
};
